
  $(document).ready(function() {
    var currentDate = new Date();
    var deliveryDate = new Date();
    var daysToAdd = 1; // Default number of days to add
  
    // Check if the current day is Saturday (6) or Sunday (0)
    if (currentDate.getDay() === 6) { // Saturday
      daysToAdd = 2; // Add 2 days to skip the weekend
    } else if (currentDate.getDay() === 0) { // Sunday
      daysToAdd = 2; // Add 1 day to skip Sunday
    }
  
    deliveryDate.setDate(currentDate.getDate() + daysToAdd);
  
    var currentMonth = currentDate.toLocaleString('default', { month: 'long' });
    var currentDay = currentDate.getDate();
    var formattedCurrentDate = currentDay + ' ' + currentMonth; // Show month after date
  
    var deliveryMonth = deliveryDate.toLocaleString('default', { month: 'long' });
    var deliveryDay = deliveryDate.getDate();
    var formattedDeliveryDate = deliveryDay + ' ' + deliveryMonth; // Show month after date
  
    $("#current-date1").text(formattedCurrentDate);
    $("#current-date2").text(formattedCurrentDate);
    $("#delivery-date").text(formattedDeliveryDate);
  });
  
   $(document).ready(function () {
    // Move the .trust_main element after .reviews--
    $(".trust_main").insertAfter(".reviews--");

    // Initialize Slick Carousel
    $(".trust-carousel").slick({
        slidesToShow: 2, // Show 3 slides at a time
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000, // Set the autoplay interval in milliseconds
        arrows: false, // Show navigation arrows
        dots: false, // Hide dots
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    // Custom Arrows
    $(".slick-prev").html('<i class="fas fa-arrow-circle-left" style="color: #acadaf;"></i>');
    $(".slick-next").html('<i class="fas fa-arrow-circle-right" style="color: #acadaf;"></i>');
});

 $(document).ready(function () {
    // Initially open accordions based on the 'open-accordion' class
    $('.faq_acc_hd.open-accordion').each(function () {
      $(this).siblings('.faq_acc_cnt').slideDown();
      $(this).addClass('active');
    });

    $('.faq_acc_hd').on('click', function () {
      if ($(this).hasClass('active')) {
        // If the accordion is currently open, close it and remove the 'active' class
        $(this).siblings('.faq_acc_cnt').slideUp();
        $(this).removeClass('active');
      } else {
        // If the accordion is currently closed, close only this one and open it
        $(this).siblings('.faq_acc_cnt').slideDown();
        $(this).addClass('active');
      }
    });
  });
